import { Icon } from '@iconify/react'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { Button, useDisclosure } from '@nextui-org/react'
import EditContactPersonModal from './EditContactPersonModal'
import EditContactDepartmentModal from './EditContactDepartmentModal'

interface IOverview {
  doc: any
  setDoc: (value: any) => void
}
export default function OverView({ doc, setDoc }: IOverview) {
  const [showFullDescription, setShowFullDescription] = useState<boolean>(false)
  const { isOpen: isContactPersonModalOpen, onOpenChange: onOpenContactPersonModalChange } = useDisclosure()
  const { isOpen: isContactDepartmentModalOpen, onOpenChange: onOpenContactDepartmentModalChange } = useDisclosure()
  return (
    doc && (
      <div className="p-1 flex flex-1 flex-col h-full">
        <div className="flex flex-row gap-10 pt-4 pb-8">
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Date of creation</span>
            <span className="text-black text-sm font-regular">{dayjs(doc.createdAt).format('DD/MM/YYYY')}</span>
          </div>
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Due date</span>
            <span className="text-black text-sm font-regular">-</span>
          </div>
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Source</span>
            <span className="text-black text-sm font-regular">-</span>
          </div>
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Place of the order</span>
            <span className="text-black text-sm font-regular">-</span>
          </div>
        </div>
        <div className="flex flex-col flex-1">
          <span className="text-black font-bold text-sm">Project summary</span>
          <span className="text-black text-sm font-regular pb-8">
            {(showFullDescription ? doc.description : (doc.description || '').substr(0, 350))
              .split('\n')
              .map((text: string, index: number) => (
                <React.Fragment key={index}>
                  <br />
                  {text}
                </React.Fragment>
              ))}
            {!showFullDescription && doc.description?.length > 350 ? '...' : ''}
          </span>
          <Button
            variant="light"
            className="p-0 hover:bg-transparent data-[hover=true]:bg-transparent w-fit"
            onPress={() => setShowFullDescription((prev) => !prev)}
          >
            <span className={'text-[#0052CC] flex flex-row items-center font-medium'}>
              <Icon icon={!showFullDescription ? 'lucide:plus' : 'lucide:minus'} color="#0052CC" fontWeight={'700'} />
              View {showFullDescription ? 'less' : 'full'} description
            </span>
          </Button>
        </div>
        <div className="flex flex-row pt-4 pb-10 gap-4">
          <div className="border-1 border-default-300 rounded-md py-4 px-4 min-h-[229px] min-w-[310px] gap-2 flex flex-col">
            <div className="flex flex-row items-center justify-between">
              <span className="text-black font-bold text-sm pb-2">Project contact person</span>
              <Button
                className="p-2 data-[hover=true]:bg-transparent"
                variant="light"
                onPress={() => onOpenContactPersonModalChange()}
              >
                <Icon icon="lucide:edit" />
              </Button>
            </div>
            <span
              className={
                doc.contactName
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:user'} fontWeight={'500'} color={'#09090B'} width={20} />
              {doc?.contactName || 'Not specified yet'}
            </span>
            <span
              className={
                doc.contactPhone
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:phone'} fontWeight={'500'} color={'#09090B'} width={20} />
              {doc?.contactPhone || 'Not specified yet'}
            </span>
            <span
              className={
                doc.contactEmail
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:mail'} fontWeight={'500'} color={'#09090B'} width={20} />
              {doc?.contactEmail || 'Not specified yet'}
            </span>
          </div>
          <div className="border-1 border-default-300 rounded-md py-4 px-4 min-h-[229px] min-w-[310px] gap-2 flex flex-col hidden">
            <div className="flex flex-row items-center justify-between">
              <span className="text-black font-bold text-sm pb-2">Contact of Departement</span>
              <Button className="p-2 data-[hover=true]:bg-transparent" variant="light">
                <Icon icon="lucide:edit" />
              </Button>
            </div>
            <span
              className={
                doc.departmentName
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:user'} fontWeight={'500'} color={'#09090B'} width={20} />
              {doc?.departmentName || 'Not specified yet'}
            </span>
            <span
              className={
                doc.departmentPhone
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:phone'} fontWeight={'500'} color={'#09090B'} width={20} />
              {doc?.departmentPhone || 'Not specified yet'}
            </span>
            <span
              className={
                doc.departmentEmail
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:mail'} fontWeight={'500'} color={'#09090B'} width={20} />
              {doc?.departmentEmail || 'Not specified yet'}
            </span>
          </div>
        </div>
        <EditContactPersonModal
          doc={doc}
          setDoc={setDoc}
          isOpen={isContactPersonModalOpen}
          onOpenChange={onOpenContactPersonModalChange}
        />
        <EditContactDepartmentModal
          doc={doc}
          setDoc={setDoc}
          isOpen={isContactDepartmentModalOpen}
          onOpenChange={onOpenContactDepartmentModalChange}
        />
      </div>
    )
  )
}
